export default __webpack_public_path__ + "static/media/grafema_capitolio_08.e3cd577a.jpg";